import React, { FC } from 'react';

import ChevroRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Calendar from 'react-calendar';
import { DateTime } from 'luxon';
import moment from 'moment';

import { activeDate, setActiveDate } from '@pharmaplan/common';

import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { MomentFormatOptions } from '../../../helpers/Constants';

import { addClassNameToDate } from './util';
import styles from './styles';
import './styles.scss';

const todayDate = new Date();
const { shortWeekDayName, fullMonthYear } = MomentFormatOptions;

interface IRangeCalendar {
  value: Date | [Date | null, Date | null] | null | undefined;
  onChange: (dateRange: Array<Date>) => void;
  openedDate?: string;
  isUpdate?:boolean
}

const RangeCalendar: FC<IRangeCalendar> = ({ openedDate, value, onChange, isUpdate }) => {
  const dispatch = useAppDispatch();
  const activeDateSelector = useAppSelector(activeDate);

  const onMonthChange = ({
    action,
    activeStartDate,
  }: {
    action: string;
    activeStartDate: Date;
  }) => {
    switch (action) {
      case 'prev':
      case 'next':
      case 'drillDown':
        dispatch(
          setActiveDate(
            DateTime.fromJSDate(activeStartDate).startOf('month').toISO() ?? '',
          ),
        );
        break;
      default:
    }
  };

  const disableTiles = () =>
    !!isUpdate;

  const formatWeekday = (_: string, date: Date) =>
    moment(date).format(shortWeekDayName);

  const formatMonth = (_: string, date: Date) =>
    moment(date).format(fullMonthYear);

  return (
    <Calendar
      minDate={todayDate}
      value={value}
      selectRange
      minDetail="year"
      onActiveStartDateChange={onMonthChange}
      defaultActiveStartDate={new Date(activeDateSelector)}
      prevLabel={<ChevronLeftIcon />}
      nextLabel={<ChevroRightIcon />}
      next2Label={null}
      formatShortWeekday={formatWeekday}
      tileDisabled={disableTiles}
      formatMonthYear={formatMonth}
      prev2Label={null}
      className={styles().yearCalendar}
      goToRangeStartOnSelect={false}
      tileClassName={addClassNameToDate(value, isUpdate, openedDate)}
      onChange={onChange}
    />
  );
};
export default RangeCalendar;
